import ServerStatisticsDataPage from "../ServerStatisticsDataPage";

export default class ZSServerStatisticsPage extends ServerStatisticsDataPage {
}
